import type { FontStyleDto } from "@repo/api/font";
import type { ElementTypographyDto } from "@repo/api/overlays";

export type TextLayoutStyle = {
  fontSize: string;
  fontWeight: string;
  fontStyle: FontStyleDto;
  fontFamily: string;
  whiteSpace: "pre";
};

export function getTextLayoutStyle(
  typography: ElementTypographyDto,
  fontFamily: string,
): TextLayoutStyle {
  return {
    fontSize: `${typography.fontSize}px`,
    fontWeight: String(typography.fontWeight),
    fontStyle: typography.fontStyle,
    fontFamily,
    whiteSpace: "pre",
  };
}
